import { axiosFactory, errorHandler, currentPage } from '@/configs/axios'

const hardwareHistory = {
  api: (payload) => {
    return axiosFactory()
      .auth.get(
        `histories/company-vehicles/devices/?company_vehicle=${payload}${currentPage(
          undefined,
          '&'
        )}`
      )
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const exportHardwareHistory = {
  api: (payload) => {
    return axiosFactory({ type: 'blob' })
      .auth.get(
        `exports/histories/company-vehicles/devices/?company_vehicle=${payload}`
      )
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const exportVehicleHistory = {
  api: (payload) => {
    return axiosFactory({ type: 'blob' })
      .auth.get(
        `exports/histories/company-vehicles/drivers/?company_vehicle=${payload}`
      )
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const vehicleHistory = {
  api: (payload) => {
    return axiosFactory()
      .auth.get(
        `histories/company-vehicles/drivers/?company_vehicle=${payload}${currentPage(
          undefined,
          '&'
        )}`
      )
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const stopsHistory = {
  api: (payload) => {
    return axiosFactory()
      .auth.get(
        '/trips/stops/' + (payload != undefined ? `?device=${payload}` : '')
      )
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

// const routingHistory = {
//   api: (payload) => {
//     return axiosFactory()
//       .auth.get(
//         `api/trips/v1/detail/?vehicle_id=${payload[0]}&start_datetime=${payload[1]}&end_datetime=${payload[2]}`
//       )
//       .then((res) => {
//         return res.data;
//       })
//       .catch((error) => {
//         return false;
//       });
//   },
// };

// const routinAnomaly = {
//   api: (payload) => {
//     return axiosFactory()
//       .auth.get(`/trips/anomalies/?trip=${payload}`)
//       .then((res) => {
//         return res.data;
//       })
//       .catch((error) => {
//         return false;
//       });
//   },
// };

const trips = {
  api: (payload) => {
    return axiosFactory()
      .auth.get(
        `trips/?company_vehicle=${payload[0]}&start_datetime=${
          payload[1]
        }&stop_datetime=${payload[2]}${currentPage(undefined, '&')}`
      )
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        // errorHandler(error);
      })
  },
}

export const v2trips = {
  api: (payload) => {
    return axiosFactory({ api: 'v2' })
      .auth.get(
        `trips/?company_vehicle=${payload[0]}&start_datetime=${
          payload[1]
        }&stop_datetime=${payload[2]}${currentPage(undefined, '&')}`
      )
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        // errorHandler(error);
      })
  },
}

export const overview = {
  api: (payload) => {
    return axiosFactory()
      .auth.get(
        `routes/company-vehicles/${payload[0]}/overviews/?start_range=${payload[1]}&stop_range=${payload[2]}&min_duration=${payload[3]}`
      )
      .then((res) => {
        return res.data
      })
      .catch((error) => {})
  },
}

export const v2overview = {
  api: (payload) => {
    return axiosFactory({ api: 'v2' })
      .auth.get(
        `routes/company-vehicles/${payload[0]}/overviews/?start_range=${payload[1]}&stop_range=${payload[2]}&min_duration=${payload[3]}`
      )
      .then((res) => {
        return res.data
      })
      .catch((error) => {})
  },
}

export const stopDownload = {
  api: (payload) => {
    return axiosFactory({ type: 'blob' })
      .auth.get(
        `exports/stops/company-vehicles/${payload[0]}/?start_range=${payload[1]}&stop_range=${payload[2]}&min_duration=${payload[3]}`
      )
      .then((res) => {
        return res.data
      })
      .catch((error) => {})
  },
}
export const overviewDetail = {
  api: (payload) => {
    return axiosFactory()
      .auth.get(
        `routes/company-vehicles/${payload[0]}/?start_range=${payload[1]}&stop_range=${payload[2]}`
      )
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        return false
      })
  },
}

export const v2overviewDetail = {
  api: (payload) => {
    return axiosFactory({ api: 'v2' })
      .auth.get(
        `routes/company-vehicles/${payload[0]}/?start_range=${payload[1]}&stop_range=${payload[2]}`
      )
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        return false
      })
  },
}

const tripsList = {
  api: (payload) => {
    return axiosFactory()
      .auth.get(
        `trips/statuses/?company_vehicle=${payload[0]}&date=${payload[1]}`
      )
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        return false
      })
  },
}

const tripDetail = {
  api: (payload) => {
    return axiosFactory()
      .auth.get('/trips/' + payload + '/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const tripReal = {
  api: (payload) => {
    return axiosFactory()
      .auth.get(`/trips/last-states/company-vehicles/${payload}/`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const DownloadperiodicReport = {
  api: (payload) => {
    const { company_vehicle, date__lte, date__gte } = payload

    const params = {
      company_vehicle__in: company_vehicle,
      date__lte,
      date__gte,
    }
    return axiosFactory({ type: 'blob' })
      .auth.get(`exports/stats/fleets/dailies/`, { params })
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const periodicReport = {
  api: (payload) => {
    const { company_vehicle, date__lte, date__gte } = payload

    // Construct query parameters from the payload
    const params = {
      company_vehicle__in: company_vehicle,
      date__lte,
      date__gte,
    }

    return axiosFactory()
      .auth.get('/stats/fleets/dailies/', { params })
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const FenceEvents = {
  api: () => {
    return axiosFactory()
      .auth.get('/geofences/events/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

// Rules events (for rule evaluations)
export const RulesEvents = {
  api: (params) => {
    return axiosFactory()
      .auth.get('/rules/events/', params ? { params } : undefined)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const RuleEventDetail = {
  api: (payload) => {
    return axiosFactory()
      .auth.get(`/rules/events/${payload}/`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const FenceEventDetail = {
  api: (payload) => {
    return axiosFactory()
      .auth.get(`/geofences/events/${payload}/`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const DailyReport = {
  api: (payload) => {
    return axiosFactory()
      .auth.get(`/stats/fleets/dailies/?date=${payload}`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const DownloadDailyReport = {
  api: (payload) => {
    return axiosFactory({ type: 'blob' })
      .auth.get(`exports/stats/fleets/dailies/?date=${payload}`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const temperatureTracking = {
  api: () => {
    return axiosFactory()
      .auth.get('trackings/temperatures/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        // errorHandler(error)
      })
  },
}

export const vehicleTemperatureTracking = {
  api: (vehicleId, startRange, stopRange) => {
    const params = new URLSearchParams()
    if (startRange) params.append('start_range', startRange)
    if (stopRange) params.append('stop_range', stopRange)

    const queryString = params.toString()
    const url = `routes/company-vehicles/${vehicleId}/temperatures/${
      queryString ? `?${queryString}` : ''
    }`

    return axiosFactory()
      .auth.get(url)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export {
  hardwareHistory,
  vehicleHistory,
  trips,
  tripDetail,
  stopsHistory,
  tripReal,
  tripsList,
  // routinAnomaly,
}
